import { useQuery } from "@apollo/client";
import { PROFILE_ANSWERS_QUERY } from "@/api/queries/profileAnswers";
import {
  ProfileAnswersQuery,
  ProfileAnswersQueryVariables,
} from "@/__generated__/types";

export interface UseProfileAnswersParams {
  userId: string;
  skip?: boolean;
}

export const useProfileAnswers = ({
  userId,
  skip = false,
}: UseProfileAnswersParams) => {
  const { data, loading, error, refetch } = useQuery<
    ProfileAnswersQuery,
    ProfileAnswersQueryVariables
  >(PROFILE_ANSWERS_QUERY, {
    variables: {
      userId,
    },
    skip,
  });

  const user = data?.node?.__typename === "User" ? data.node : null;

  return {
    answers: user?.profileAnswers?.nodes || [],
    loading,
    error,
    refetch,
  };
};
